import BaseMenu from './components/BaseMenu';
import DropdownMenu from './components/DropdownMenu';

const Menu = BaseMenu;

Menu.Dropdown = DropdownMenu;

export default Menu;
